<template>
  <div class="ff-menu" @mouseleave="$emit('mouseleave', $event)">
    <ff-input v-if="showInput" v-model="inputValue" :action="sendInput" :search="true" :data-ref="trigger" placeholder="Search Pages"/>
    <aside class="ff-menu__label" v-if="label">{{label}}</aside>
    <li
      class="ff-menu__item"
      v-for="(item, index) in items"
      :data-test="item.test || 'menu-item'"
      :key="index"
      @click="action(item)"
    >
      <ph-newspaper class="ff-menu__item-icon" v-if="item.icon === 'newspaper'"></ph-newspaper>
      <ph-trash class="ff-menu__item-icon" v-if="item.icon === 'trash'"></ph-trash>
      <ph-lock-key class="ff-menu__item-icon" v-if="item.icon === 'lock'"/>
      <span class="ff-menu__item-heading">{{item.title}}</span>
      <aside class="ff-menu__item-subheading" v-if="item.subheading">{{item.subheading}}</aside>
    </li>
  </div>
</template>

<script>
import { PhNewspaper, PhTrash, PhLockKey } from 'phosphor-vue'
import FFInput from './FFInput'

export default {
  name: 'ff-menu',
  props: [
    'items',
    'showInput',
    'trigger',
    'label'
  ],
  components: {
    PhNewspaper,
    PhTrash,
    PhLockKey,
    'ff-input': FFInput
  },
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
  },
  methods: {
    action (item) {
      this.$emit('action', item)
    },
    sendInput () {
      this.$emit('input', this.inputValue)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-menu {
    font-size: $fontSize-normal;
    padding: $unit-1;
    box-shadow: $boxShadow;
    border-radius: 6px;
    background: $color-white;
    width: 16rem;
    z-index: 1;
    right: 0;
    transition: .2s ease all;
  }

  .ff-menu__label {
    @include caps;
    color: $color-darkish;
    padding: $unit-1;
  }

  .ff-menu__item {
    list-style: none;
    margin-bottom: $unit-1;
    font-size: $fontSize-normal;
    padding: $unit-1;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background: $color-almost-white;
      cursor: pointer;
      border-radius: $borderRadius;
    }
  }

  .ff-menu__item-heading {
    display: inline-block;
    font-weight: 500;
  }

  .ff-menu__item-subheading {
    color: $color-darkish;
  }

  .ff-menu__item-icon {
    width: 18px;
    height: 18px;
    margin-right: .5rem;
    vertical-align: bottom;
    display: inline-block;
  }

</style>
